import React, { useMemo } from 'react';
import { JsonPropsType } from '../../../component-loader';
import { Workflow, DocumentsDataResponse } from './types';
import { useDocumentFilters } from './hooks/useDocumentFilters';
import { DocumentListHeader } from './DocumentListHeader';
import { ScrollableWithGradient } from '../../common/ui/ScrollableWithGradient';
import { DocumentsTable } from './DocumentsTable';

export interface DocumentListProps extends JsonPropsType {
  jsonObject: DocumentsDataResponse;
}

function FoundDocumentsMessage({ count }: { count: number }) {
  return (
    <p className="text-muted mb-0" style={{ fontSize: '12px' }}>
      Encontramos
      {' '}
      {count}
      {' '}
      documento
      {count !== 1 ? 's' : ''}
      {' '}
      que cumplen con tu búsqueda.
    </p>
  );
}

export function DocumentList(props: DocumentListProps) {
  const jsonData = props.jsonObject;
  const documentsByWorkflow = jsonData.documentsByWorkflow || {};

  const workflows = useMemo<Workflow[]>(() => {
    const workflowList: Workflow[] = [
      {
        id: null,
        name: 'all',
        displayName: 'Todos',
        documentCount: Object.values(documentsByWorkflow).flat().length,
      },
    ];

    Object.entries(documentsByWorkflow).forEach(([workflowName, documents]) => {
      workflowList.push({
        id: null,
        name: workflowName,
        displayName: workflowName,
        documentCount: documents.length,
      });
    });

    return workflowList;
  }, [documentsByWorkflow]);

  const {
    filters,
    availableCategories,
    filteredDocuments,
    updateWorkflow,
    updateCategories,
    updateSearch,
  } = useDocumentFilters(documentsByWorkflow);

  return (
    <>
      <DocumentListHeader
        workflows={workflows}
        activeWorkflow={filters.workflow}
        searchValue={filters.search}
        selectedCategories={filters.category}
        availableCategories={availableCategories}
        onWorkflowChange={updateWorkflow}
        onSearchChange={updateSearch}
        onCategoriesChange={updateCategories}
      />
      <section className="row g-4">
        <div className="col-12">
          <ScrollableWithGradient maxHeight="50svh" gradientHeight={100}>
            <DocumentsTable documents={filteredDocuments} />
          </ScrollableWithGradient>
        </div>
        <div className="col-12">
          <FoundDocumentsMessage count={filteredDocuments.length} />
        </div>
      </section>
    </>
  );
}
